import React from 'react'

import SupportListWrapper from 'core/page/SupportListWrapper'
import { loadExportedInvoices } from '../state/action'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { AccountancyExportStatus, AccountancySoftware, IPaginatedRequest, InvoiceExportListItem } from '@cbgms/api'
import { fields, query } from '@cbgms/components/list'
import FormButtonsFC from '@cbgms/components/layout/FormButtons'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const AccountancyErrorList: React.FC = () => {
  const { shopID, administrationSoftware } = useParams<{
    shopID: string
    administrationSoftware: string
  }>()
  const history = useHistory()
  const { t } = useTranslation()

  const location = useLocation<{ administrationDescription?: string }>()
  const searchParams = new URLSearchParams(location.search)

  const administrationDescription = location.state?.administrationDescription || searchParams.get('description') || ' '

  const hasSpecial = administrationDescription.includes(')')
  const beforeSpecial = administrationDescription.split(')')[0].trim()

  const requiredColumns = fields<InvoiceExportListItem>()
    .add(o => o.InvoiceExport.AdministrationSoftware)
    .add(o => o.InvoiceExport.AdministrationDescription)
    .add(o => o.InvoiceExport.InvoiceNumber)
    .add(o => o.InvoiceExport.Status)
    .add(o => o.InvoiceExport.ErrorMessage)
    .add(o => o.InvoiceExport.ResponseLog)
    .add(o => o.InvoiceExport.CreatedAt)
    .add(o => o.InvoiceExport.InvoiceDate)
    .add(o => o.InvoiceExport.SentAt)
    .toString()

  const searchQuery = !hasSpecial
    ? query<InvoiceExportListItem>()
        .equals('InvoiceExport.ShopID', shopID)
        .and()
        .equals('InvoiceExport.AdministrationSoftware', administrationSoftware as AccountancySoftware)
        .and()
        .equals('InvoiceExport.AdministrationDescription', administrationDescription)
        .and()
        .equals('InvoiceExport.Status', AccountancyExportStatus.Error)
        .toString()
    : query<InvoiceExportListItem>()
        .equals('InvoiceExport.ShopID', shopID)
        .and()
        .equals('InvoiceExport.AdministrationSoftware', administrationSoftware as AccountancySoftware)
        .and()
        .contains('InvoiceExport.AdministrationDescription', beforeSpecial)
        .and()
        .equals('InvoiceExport.Status', AccountancyExportStatus.Error)
        .toString()

  const onCancel = () => {
    localStorage.removeItem('administrationDescriptionSupport')
    history.push('/troubleshoot/accountancy')
  }

  const loadAccountancyExportInvoices = (params: IPaginatedRequest) => {
    return loadExportedInvoices({
      ...params,
      fields: requiredColumns,
      search: [params.search, searchQuery].filter(Boolean).join(',')
    })
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <Typography variant='h6'>
          {t('reporting.export-error-list-for')} {t(`Enum.EnumAccountancySoftware_${administrationSoftware}`)} {shopID && `(${shopID})`}
        </Typography>
        <FormButtonsFC onCancel={onCancel} />
      </div>

      <SupportListWrapper
        scope='errored-invoices'
        type='list-with-related'
        skipDryRun
        loadAction={loadAccountancyExportInvoices}
        translationKey='settings_exported_invoices'
      />
    </div>
  )
}

export default AccountancyErrorList
